<template>
  <hooper :settings="hooperSettings"  style="height: 20rem">
    <slide v-for="url in imageUrlList">
      <b-img fluid :src="url"></b-img>
    </slide>
    <navigation slot="hooper-addons"/>
  </hooper>
</template>

<script>
  import {Hooper, Slide, Navigation} from 'hooper';
  import 'hooper/dist/hooper.css';

  export default {
    name: "DistressImageContainer",
    components: {
      Hooper,
      Slide,
      Navigation
    },
    computed: {
      hooperSettings() {
        return {
          itemsToShow: 1,
          centerMode: true,
          breakpoints: {
            800: {
              centerMode: false,
              itemsToShow: 2
            }
          }

        }
      },
      imageUrlList() {
        const baseUrl = '/assets/distress_img';
        const folder = 'alligator';
        const filenames = [
          'alligator_1.JPG',
          // 'jaf_alligator03.jpg',
          'jy_alligator02.jpg'
        ];

        return filenames.map((fn) => baseUrl + '/' + folder + '/' + fn)
      }
    },
  }
</script>

<style scoped>

</style>